<template>
  <div>
    <div class="yxHeadCont">
      <div class="headBox">
        <div class="logo img">
          <img :src="$imgUrl + info.logo" alt="" />
        </div>
        <div class="box">
          <div class="titleBox">
            <div class="name">{{ info.name }}</div>
            <!-- <div class="dzBox">
              <div class="iconfont icon-coordinates"></div>
              <div class="txt">{{ info.address }}</div>
            </div> -->
          </div>
          <div class="texts">
            <div class="text">{{ info.address }}</div>
          </div>
        </div>
        <div class="gzBox">
          <div class="name" @click="gwJump">进入官网</div>
        </div>
      </div>
      <div class="cont">
        <div class="imgs">
          <a-carousel arrows autoplay>
            <div class="img">
              <img
                src="https://static-data.gaokao.cn/upload/school/201910/1554861735_6541_thumb.jpg"
                alt=""
              />
            </div>
          </a-carousel>
        </div>
        <div class="box">
          <div class="typeList">
            <div class="typeBox">
              <div class="num">{{ info.class }}</div>
              <div class="name">班级数量</div>
            </div>
            <div class="typeBox">
              <div class="num">{{ info.student }}</div>
              <div class="name">学生数量</div>
            </div>
            <div class="typeBox">
              <div class="num">{{ info.teacher }}</div>
              <div class="name">师资数量</div>
            </div>
            <div class="typeBox">
              <div class="num">{{ info.higher }}</div>
              <div class="name">升学率</div>
            </div>
            <div class="typeBox">
              <div class="num">{{ info.area }}</div>
              <div class="name">占地</div>
            </div>
            <div class="typeBox">
              <div class="num">{{ info.establish }}</div>
              <div class="name">建校时间</div>
            </div>
          </div>
          <div class="list">
            <div class="li">
              <div class="name">
                学校官网：<a :href="info.url">{{
                  info.url ? info.url : "暂无信息"
                }}</a>
              </div>
            </div>
            <div class="li">
              <div class="name">招生电话：{{ info.mobile }}</div>
            </div>
            <div class="li">
              <div class="name">
                电子邮箱：{{ info.email ? info.email : "暂无内容" }}
              </div>
            </div>
            <!-- <div class="li">
              <div class="name">
                监督举报：{{
                  info.report_mobile ? info.report_mobile : "暂无内容"
                }}
              </div>
            </div> -->
            <div class="li">
              <div class="name">
                学校地址： {{ info.address ? info.address : "暂无内容" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftCont">
        <div class="headText">学校概况</div>
        <div class="gkCont">
          <div class="text" v-html="info.content"></div>
        </div>
        <div class="headText">学校地图</div>
        <div class="mapBox">
          <div :style="{ width: '100%', height: '260px' }" id="getMap"></div>
        </div>
        <!-- <div class="headText">招生计划</div>
        <div class="zsCont">
          <div class="box">
            <div class="name">普通班</div>
            <div class="texts">
              <div class="txtBox">
                <div class="txt">招生人数</div>
                <div class="text">40人</div>
              </div>
              <div class="txtBox">
                <div class="txt">学费</div>
                <div class="text">5000元/学期</div>
              </div>
              <div class="txtBox">
                <div class="txt">学制</div>
                <div class="text">3年</div>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="name">高考班</div>
            <div class="texts">
              <div class="txtBox">
                <div class="txt">招生人数</div>
                <div class="text">40人</div>
              </div>
              <div class="txtBox">
                <div class="txt">学费</div>
                <div class="text">5000元/学期</div>
              </div>
              <div class="txtBox">
                <div class="txt">学制</div>
                <div class="text">3年</div>
              </div>
            </div>
          </div>
          <div class="box">
            <div class="name">普通班</div>
            <div class="texts">
              <div class="txtBox">
                <div class="txt">招生人数</div>
                <div class="text">40人</div>
              </div>
              <div class="txtBox">
                <div class="txt">学费</div>
                <div class="text">5000元/学期</div>
              </div>
              <div class="txtBox">
                <div class="txt">学制</div>
                <div class="text">3年</div>
              </div>
            </div>
          </div>
        </div>
        <div class="headText">报考条件</div>
        <div class="gkCont">
          <div class="text">
            报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍报考条件介绍
          </div>
        </div> -->
        <div class="headText">学校优秀人才</div>
        <div class="peoBox" v-if="memberjob.length != 0">
          <div class="cont" v-for="item in memberjob">
            <div class="contLeft">
              <div class="imgBox">
                <div class="img">
                  <img :src="$imgUrl + item.avatars" alt="" />
                </div>
                <div class="money dis-cent">
                  {{ item.minprice }}k-{{ item.maxprice }}k
                </div>
              </div>
            </div>
            <div class="contRit">
              <div class="name">{{ item.member_info.realname }}</div>
              <div class="txtBox">
                <div class="txt" v-if="item.age != 2024">{{ item.age }}岁</div>
                <div class="txt" v-if="item.age == 2024">未填写</div>
                <div class="shu"></div>
                <div class="txt">
                  {{
                    item.member_info.experience_cn
                      ? item.member_info.experience_cn
                      : "未填写"
                  }}
                </div>
                <!-- <div class="shu"></div>
                    <div class="txt">{{ item.district_cn }}</div> -->
                <div class="shu"></div>
                <div class="txt">
                  {{
                    item.member_info.current_cn
                      ? item.member_info.current_cn
                      : "未填写"
                  }}
                </div>
                <div class="shu"></div>
              </div>
              <div class="textBox">
                <div class="txt">期望职位：</div>
                <div class="text">{{ item.intention_jobs }}</div>
              </div>
              <div class="textBox">
                <div class="txt">毕业院校：</div>
                <div class="texts c-1" v-if="item.member_education.id">
                  <div class="text">{{ item.member_education.school }}</div>
                  <div class="yuan"></div>
                  <div class="text">{{ item.member_education.speciality }}</div>
                  <!-- <div class="yuan"></div>
                <div class="text">{{item.member_education.education_cn}}</div> -->
                </div>
                <div class="text" v-else>暂无信息</div>
              </div>
              <div class="typeBox">
                <div class="txt" v-if="item.member_info.education_cn">
                  {{ item.member_info.education_cn }}
                </div>
                <template v-if="item.district_cn1">
                  <div class="txt" v-for="itemq in item.district_cn1">
                    {{ itemq }}
                  </div>
                </template>
                <template v-else>
                  <div class="txt">{{ item.district_cn }}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="bysList"></div>
        <div class="fenye" v-if="totalCount > 20">
          <a-pagination
            :default-current="page.pageNo"
            v-model="page.pageNo"
            :total="totalCount"
            :page-size="20"
            @change="pageOnChange"
          />
        </div>
      </div>
      <div class="ritCont">
        <!-- <div class="cont">
          <div class="headBox">学校咨询</div>
          <div class="ggBox">
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
            <div class="textBox">
              <div class="name">内容内容内容内容内容内容内容内容内容内容</div>
            </div>
          </div>
        </div> -->
        <div class="cont">
          <div class="headBox">优秀毕业生</div>
          <!-- <div class="xxBox" v-for="item in school">
            <div class="img">
              <img :src="$imgUrl + item.logo" alt="" />
            </div>
            <div class="name">{{ item.name }}</div>
          </div> -->
          <div class="bysList">
            <div class="box" v-for="item in list">
              <div class="name">{{ item.name }}</div>
              <div class="mobile">{{ item.mobile }}</div>
              <div class="txt">{{ item.specialityname }}</div>
              <div class="txt">{{ item.year }}年</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TiandituLoader from "@/assets/js/tianditu";
export default {
  name: "",
  data() {
    return {
      id: "",
      info: {},
      school: [],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 20,
      },
      list: [],
      totalCount: 0,
      memberjob: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.get();
    this.listGet();
  },
  methods: {
    mapGet() {
      let that = this;
      TiandituLoader.load().then((Tianditu) => {
        that.showMap(Tianditu);
      });
    },
    showMap(Tianditu) {
      let maplist = this.maplist;
      this.map = new Tianditu.Map("getMap", {
        resizeEnable: true,
        center: [this.info.lng, this.info.lat],
        zoom: 16,
      });
      let markers = [];
      // for (let i = 0; i < maplist.length; i++) {
      var marker = new Tianditu.Marker({
        position: [this.info.lng, this.info.lat],
        offset: new Tianditu.Pixel(-13, -30),
      });
      markers.push(marker);
      // }
      this.map.add(markers);
      // 添加点坐标
      // this.map.add(this.marker);
    },
    gwJump() {
      window.open(this.school.url);
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/school_student", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 1; i < res.data.length; i++) {
            const e = res.data[i];
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    get() {
      this.$get("/nozzle/web/school_get", {
        id: this.id,
      }).then((res) => {
        console.log(res);
        this.mapGet();
        this.info = res.data;
        this.school = res.school;
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.yxHeadCont {
  width: 1280px;
  border-radius: 10px;
  background-color: #fff;
  padding: 25px;
  margin: auto;
  margin-top: 15px;
  .headBox {
    padding-bottom: 25px;
    display: flex;
    border-bottom: 1px solid #ebebeb;
    align-items: center;
    .logo {
      width: 210px;
      height: 80px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .box {
      width: calc(100% - 310px);
      padding-left: 15px;
      box-sizing: border-box;
      height: 80px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .titleBox {
        display: flex;
        align-items: center;
        .name {
          font-size: 24px;
          margin-right: 12px;
          font-weight: 600;
        }
        .dzBox {
          border: 1px solid #c9c9c9;
          padding: 0 5px 0 2px;
          border-radius: 25px;
          height: 25px;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #888;
          position: relative;
          top: 1px;
        }
      }
      .texts {
        display: flex;
        align-items: center;
        .text {
          margin-right: 15px;
          background-color: #ebebeb;
          border-radius: 5px;
          padding: 5px 10px;
          font-size: 14px;
          color: #666;
        }
      }
    }
    .gzBox {
      width: 100px;
      .name {
        width: 100px;
        height: 45px;
        background-color: #2283f1;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
      }
    }
  }
  .cont {
    display: flex;
    padding-top: 25px;
    .imgs {
      width: 440px;
      height: 250px;
      border-radius: 10px;
      overflow: hidden;
      img {
        width: 440px;
        object-fit: cover;
        height: 250px;
        border-radius: 10px;
      }
    }
    .box {
      width: calc(100% - 440px);
      height: 250px;
      box-sizing: border-box;
      padding-left: 20px;
      .typeList {
        display: flex;
        align-items: center;
        .typeBox {
          width: 109px;
          height: 60px;
          background: #f2fbff;
          border-radius: 8px;
          border: 1px solid #e6f7ff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
          .num {
            color: rgb(0, 162, 255);
            margin-bottom: 8px;
            text-align: center;
            height: 14px;
            font-weight: 600;
            font-size: 18px;
            line-height: 14px;
          }
          .name {
            color: #666;
            font-size: 14px;
            line-height: 16px;
            padding: 0 4px;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .list {
        margin-top: 20px;
        .li {
          margin-bottom: 15px;
          font-size: 15px;
        }
      }
    }
  }
}
.content {
  width: 1280px;
  margin: auto;
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
  .leftCont {
    width: calc(100% - 360px);
    border-radius: 10px;
    background-color: #fff;
    padding: 15px;
    .headText {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 15px;
    }
    .gkCont {
      .text {
        text-indent: 2em;
        line-height: 150%;
        color: #666;
        margin-bottom: 10px;
        font-size: 15px;
      }
    }
    .mapBox {
      border-radius: 10px;
      overflow: hidden;
      margin-bottom: 20px;
    }
    .zsCont {
      margin-bottom: 20px;
      .box {
        margin-bottom: 15px;
        .name {
          font-size: 18px;
          margin-bottom: 10px;
        }
        .texts {
          display: flex;
          align-items: center;
          .txtBox {
            display: flex;
            font-size: 16px;
            align-items: center;
            margin-right: 20px;
            .txt {
              color: #888;
              margin-right: 5px;
            }
          }
        }
      }
      .box:last-child {
        margin-bottom: 0;
      }
    }
    .peoBox {
      display: flex;
      flex-wrap: wrap;
      margin-top: 15px;
      .cont {
        width: calc(33.33% - 10px);
        margin-right: 15px;
        border-radius: 5px;
        background-color: #fff;
        padding: 15px;
        margin-bottom: 15px;
        display: flex;
        .contLeft {
          width: 60px;
          .imgBox {
            width: 60px;
            .img {
              height: 60px;
              width: 60px;
              border-radius: 50%;
              img {
                border-radius: 50%;
              }
            }
            .money {
              width: 60px;
              height: 20px;
              border-radius: 20px;
              background-color: #f34e1c;
              color: #fff;
              margin-top: 10px;
              font-size: 12px;
              font-weight: 600;
            }
          }
        }
        .contRit {
          width: calc(100% - 60px);
          padding-left: 15px;
          box-sizing: border-box;
          .name {
            font-weight: 500;
            font-size: 16px;
          }
          .txtBox {
            display: flex;
            align-items: center;
            font-size: 12px;
            margin-top: 5px;
            .shu {
              width: 1px;
              height: 13px;
              background-color: #c9c9c9;
              margin: 0 8px;
            }
            .shu:last-child {
              display: none;
            }
          }
          .textBox {
            display: flex;
            align-items: center;
            font-size: 12px;
            margin-top: 5px;
            .txt {
              color: #999;
              width: 60px;
            }
            .texts {
              display: flex;
              align-items: center;
              width: calc(100% - 60px);
              .yuan {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #c9c9c9;
                margin: 0 6px;
              }
            }
          }
          .typeBox {
            display: flex;
            margin-top: 10px;
            .txt {
              padding: 3px 6px;
              background-color: whitesmoke;
              margin-right: 10px;
              border-radius: 5px;
              color: #333;
              font-size: 12px;
            }
          }
        }
      }
      .cont:nth-child(3n) {
        margin-right: 0;
      }
    }
    .bysList {
      display: flex;
      flex-wrap: wrap;
      .box {
        display: flex;
        align-items: center;
        height: 40px;
        padding: 15px;
        border-radius: 10px;
        background-color: #ebebeb;
        width: calc(50% - 7.5px);
        margin-right: 15px;
        margin-bottom: 15px;
        justify-content: space-around;
        .name {
          font-weight: 600;
          font-size: 16px;
          margin-right: 15px;
        }
        .mobile {
          margin-right: 15px;
        }
        .txt {
          margin-right: 15px;
        }
        .txt:last-child {
          margin-right: 0;
        }
      }
      .box:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
  .ritCont {
    width: 360px;
    padding-left: 20px;
    box-sizing: border-box;
    .ggCont {
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 180px;
      color: #9c9c9c;
      font-size: 18px;
      margin-bottom: 20px;
    }
    .cont {
      background-color: #fff;
      border-radius: 5px;
      overflow: hidden;
      margin-bottom: 20px;
      .headBox {
        padding: 0 20px;
        font-size: 16px;
        font-weight: 500;
        color: #333;
        line-height: 47px;
        border-bottom: 1px solid #ededed;
        position: relative;
        display: -ms-flexbox;
        display: flex;
        min-width: 0;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-align: center;
        align-items: center;
      }
      .ggBox {
        padding: 20px;
        .textBox {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          cursor: pointer;
          .name {
            width: calc(100% - 0px);
          }
          .time {
            width: 80px;
            text-align: right;
          }
        }
        .textBox:last-child {
          margin-bottom: 0;
        }
      }
      .xxBox {
        display: flex;
        padding: 10px 15px 0 15px;
        align-items: center;
        .img {
          width: 95px;
          height: 26px;
          margin-right: 10px;
        }
        .name {
          font-size: 15px;
        }
      }
      .xxBox:last-child {
        padding-bottom: 10px;
      }
      .bysList {
        padding: 10px;
        .box {
          display: flex;
          align-items: center;
          height: 40px;
          padding: 15px;
          border-radius: 10px;
          background-color: whitesmoke;
          // width: calc(50% - 7.5px);
          // margin-right: 15px;
          width: 100%;
          margin-bottom: 15px;
          justify-content: space-around;
          .name {
            font-weight: 600;
            font-size: 16px;
            margin-right: 15px;
          }
          .mobile {
            margin-right: 15px;
          }
          .txt {
            margin-right: 15px;
          }
          .txt:last-child {
            margin-right: 0;
          }
        }
        .box:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
